import api from './api';

export type Status = {
  status: 'Online' | 'Offline';
};

export const entityStatusApi = api.injectEndpoints({
  endpoints: (build) => ({
    getEntityStatus: build.query<Status, string>({
      query: (entityId) => ({
        url: `/entities/${entityId}/state`,
      }),
      providesTags: ['EntityStatus'],
    }),
  }),
});

export const { useGetEntityStatusQuery } = entityStatusApi;
